import React, { useState } from "react";
import { customUnitGroups, customPreset, UNIT_LABEL_MAX } from "../../utils/habitUnits";

// ─── CUSTOM UNIT PICKER ───────────────────────────────────────────────────────
// Opens inline in the habit form, under its "Custom unit  km ›" row (Jade,
// 2026-10-09 — it was a centred pop-up first): one heading per
// group (Distance, Volume, … — customUnitGroups in habitUnits.js, Money showing
// the phone's own currency) with its units as chips, and "Other" at the bottom
// to type any name. Picking a built-in also hands back its starting goal;
// a typed name keeps whatever goal the form already has.

// A light wash of the accent: --c-bg-soft is plain white on some themes,
// which made the chips vanish on this white panel.
const TINT = "color-mix(in srgb, var(--c-primary) 10%, var(--c-bg-card))";

export function UnitPicker({ value, onPick }) {
  const current = String(value || "").trim();
  const [typed, setTyped] = useState(current && !customPreset(current) ? current : "");
  const groups = customUnitGroups();
  const name = typed.trim();

  const chip = (on) => ({
    fontSize: 13.5, fontWeight: 700, padding: "6px 12px", borderRadius: 16, border: "none", whiteSpace: "nowrap",
    fontFamily: "inherit", cursor: "pointer",
    background: on ? "var(--c-bg-active)" : TINT, color: on ? "var(--c-text-accent)" : "var(--c-text)",
    boxShadow: on ? "0 0 0 1.5px var(--c-primary)" : "none",
  });
  const heading = { fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "var(--c-text-accent)", margin: "14px 0 7px" };

  return (
      <div style={{ background: "var(--c-bg-card)", borderRadius: 16, padding: "2px 14px 14px", marginTop: 8, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
        {groups.map(g => (
          <div key={g.title}>
            <p style={heading}>{g.title}</p>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {g.units.map(pr => (
                <button key={pr.label} type="button" style={chip(current === pr.label)}
                  onClick={() => onPick({ unitLabel: pr.label, dailyCount: pr.goal })}>
                  {pr.label}
                </button>
              ))}
            </div>
          </div>
        ))}
        <div style={{ borderTop: "1px solid var(--c-border-light, #eee)", marginTop: 16, paddingTop: 12 }}>
          <p style={{ ...heading, marginTop: 0 }}>Other</p>
          <div style={{ display: "flex", gap: 8 }}>
            <input autoComplete="off" placeholder="Type a name, e.g. pushups" maxLength={UNIT_LABEL_MAX} value={typed} aria-label="Unit name"
              onChange={e => setTyped(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter" && name) onPick({ unitLabel: name }); }}
              style={{ flex: 1, minWidth: 0, fontSize: 15, padding: "8px 10px", borderRadius: 12, border: "none", outline: "none", fontFamily: "inherit", background: TINT, color: "var(--c-text)" }} />
            <button type="button" disabled={!name} onClick={() => onPick({ unitLabel: name })}
              style={{ fontSize: 14, fontWeight: 700, padding: "8px 16px", borderRadius: 12, border: "none", fontFamily: "inherit", cursor: name ? "pointer" : "default",
                background: "var(--c-primary)", color: "var(--c-on-primary, #fff)", opacity: name ? 1 : 0.45 }}>
              Use
            </button>
          </div>
        </div>
      </div>
  );
}
